import { useEffect } from 'react';
import { App } from '@capacitor/app';
import { handleOverlayBack } from '@lib/overlay/mutex';
import { isNativePlatform } from '@lib/platform';

/**
 * Android hardware back button. Registered on every native platform, but
 * only Android's Capacitor runtime ever emits `backButton`.
 * The overlay mutex gets first refusal via handleOverlayBack (§6.5): a held
 * grant either runs its own veto or dismisses. Back navigation/app exit runs
 * only when handleOverlayBack declines — no grant holder, or a takeover active.
 */
export const NativeBackButton = (): null => {
  useEffect(() => {
    if (!isNativePlatform()) return;

    const handle = App.addListener('backButton', ({ canGoBack }) => {
      if (handleOverlayBack()) return;
      if (canGoBack) {
        window.history.back();
      } else {
        void App.exitApp();
      }
    });

    return () => {
      void handle.then(h => h.remove());
    };
  }, []);

  return null;
};
